
import React, { useState } from "react"
import { FormattedMessage, injectIntl, defineMessages } from "react-intl"
import SendEmailModal from "../common/email/sendemail.component"
import IntlProps from "../state/helpers/IntlProps"
import { PROPOSAL_TYPE } from "../state/proposal/ProposalType"
import CustomOrderStatusSelect from "./SelectComponent"
import GlobalHelper from "../common/GlobalHelper.jsx"
import { OrderStatusAutomationConfiguration } from "./OrderStatusAutomation"

type Props = {
    configuration?: OrderStatusAutomationConfiguration
    onClose: () => void
    onSave: (config: OrderStatusAutomationConfiguration) => void
}

const messages = defineMessages({
    create: {
        id: "triggers.trigger_type.order_status_update_trigger.modal.edit.create",
        defaultMessage: "Create"
    },
    save: {
        id: "triggers.trigger_type.order_status_update_trigger.modal.edit.save",
        defaultMessage: "Save"
    },
})


const EmailNotificationAutomationModal = (props: Props & IntlProps) => {

    const emailTemplateKey = GlobalHelper.getEmailTemplateByProposalType(PROPOSAL_TYPE.ORDER)

    const [orderStatusConfig, setOrderStatusConfig] = useState<OrderStatusAutomationConfiguration>(props.configuration || {
        id: "",
        customStatusId: "",
        emailSubject: "",
        emailContent: "",
        emailFromName: "",
        fromEmailAddress: "",
        buttonLabel: "",
    })

    const onStatusChange = (newStatusId: string) => {
        setOrderStatusConfig(orderStatusConfig => ({ ...orderStatusConfig, customStatusId: newStatusId }))
    }

    const onSave = (subject: string, content: string, fromName: string, fromEmail: string[], buttonLabel: string) => {
        const newConfig: OrderStatusAutomationConfiguration = {
            id: orderStatusConfig.id,
            customStatusId: orderStatusConfig.customStatusId,
            emailSubject: subject,
            emailContent: content,
            emailFromName: fromName,
            fromEmailAddress: fromEmail[0],
            buttonLabel: buttonLabel,
        }
        props.onSave(newConfig)
    }

    return <>
        <SendEmailModal
            customFormElement={
                <div className="form-group row mb-1">
                    <label className="col-2 col-form-label custom-form-label pb-2" htmlFor="custom-order-status-label">
                        <FormattedMessage
                            id="common.send_email.modal.order_status_label"
                            defaultMessage="Order status"
                        />
                    </label>
                    <div className="col-10">
                        <CustomOrderStatusSelect
                            customStatusId={orderStatusConfig.customStatusId}
                            onStatusChange={onStatusChange}
                        />
                    </div>
                </div>
            }
            lastEmailSubject={orderStatusConfig.emailSubject}
            lastEmailContent={orderStatusConfig.emailContent}
            lastEmailButtonLabel={orderStatusConfig.buttonLabel}
            noEmail={true}
            title={""}
            fromName={orderStatusConfig.emailFromName}
            onSubmit={
                (subject, toEmail, ccEmail, content, buttonLabel, pdfIncluded, templateKey, fromEmail, bccEmail, fromName) => {
                    onSave(subject, content, fromName, fromEmail, buttonLabel)
                }}
            onClose={() => {
                props.onClose()
            }}
            templateKey={emailTemplateKey}
            proposalType={PROPOSAL_TYPE.ORDER}
            ctaLabel={props.intl.formatMessage(orderStatusConfig.id ? messages["save"] : messages["create"])}
            fromEmail={[orderStatusConfig.fromEmailAddress]}
            initialLoading={true}
            isCustomFromName={true}
        />
    </>
}

export default injectIntl(EmailNotificationAutomationModal)


// WEBPACK FOOTER //
// ./src/order-status/EmailNotificationAutomationModal.tsx